import { NextConversationPayload } from '../types';
import { fetchJSON }               from '../helpers/fetchTools';
import env                         from '../env';
import { UserSession }             from '../types';

export const getSmartListStatus = (session: UserSession): Promise<boolean> => fetchJSON(`${env.WEBAPP_HOST}v2/api/smart-list/arrows?has_sms_entry=true`, {
    headers: new Headers({
        Authorization: `Bearer ${session.token}`
    }),
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache'
});

export const getNextConversation = (session: UserSession): Promise<NextConversationPayload> => fetchJSON(`${env.WEBAPP_HOST}v2/api/smart-list/arrows/next`, {
    headers: new Headers({
        Authorization: `Bearer ${session.token}`
    }),
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache'
});



// WEBPACK FOOTER //
// ./src/services/NextConversationService.ts